var ko = require('knockout'),
  Cart = require('_components/organisms/shopping-cart/shopping-cart-storage'),
  APIHelper = require('_js/APIHelper'),
  AUTHORIZATION_TYPE = require('_js/constants/authorization'),
  CalculatorTracking = require('./calculator-tracking'),
  decodeHtml = require('_utils/text');

require('knockout-postbox');

var MONTH_TYPE = {
  NOVEMBER: 10,
  DECEMBER: 11
};

function CalculatorRN(params) {
  var self = this;
  // Set up listeners to resize event so that we can tell if it's a mobile
  // view or not.
  this.mobileSize = ko.observable('large').subscribeTo('resize', true);
  this.mobileView = ko.computed(function() {
    if (self.mobileSize() === 'small') {
      return true;
    } else {
      return false;
    }
  });
  this.params = params;
  this.actorId = params.actorId;
  this.showRequirementWarningsAllYear = ko.observable(
    params.showRequirementWarningsAllYear
  );
  this.API = params.api;
  this.links = params.links;
  this.texts = params.texts;
  this.isRNFriProduct = params.isRNFriProduct;
  this.calculatorInfoText = decodeHtml(params.texts.calculatorInfoText);
  this.calculatorPreviousYearInfoText = decodeHtml(
    params.texts.calculatorPreviousYearInfoText
  );
  this.descriptionCourseStudyStatus = ko.observable('');
  this.data = {
    timestatus: {
      title: decodeHtml(this.texts.titleCourseStudyStatus),
      texts: this.texts
    },
    manglerKurs: {
      title: this.texts.missingCourseTitle,
      description: decodeHtml(this.texts.missingCourseDescription),
      forwardLink: this.links.findCoursesLink,
      forwardLinkText: this.texts.findCourseLinkText
    }
  };
}

CalculatorRN.prototype.init = function(element) {
  this.$element = $(element);
  this.$htmlBody = $('html, body');
  this.categories = ko.observableArray([]).syncWith('categories', true);

  // If authorizedAccountant is set, we set the calculator type to accountent. Else we set it to auditor.
  var startAuth = window.authorizedAccountant
    ? AUTHORIZATION_TYPE.ACCOUNTANT
    : AUTHORIZATION_TYPE.AUDITOR;
  this.calculatorType = ko
    .observable(startAuth)
    .subscribeTo('authorizationType', true);
  // Used by the API call methods to detect if it was triggered by the user switching authorization type.
  this.changeInAuthorizationType = false;

  this.showCalculatorType = ko.observable(false);
  // Only show the accountant and auditor tabs if the user is both types.
  if (window.authorizedAccountant && window.authorizedAuditor) {
    this.showCalculatorType(true);
  }

  this.showLeaveBlock = ko.observable(false);
  this.showAddCourse = ko.observable(false);
  this.showCalculatorDescription = this.mobileView()
    ? ko.observable(false)
    : ko.observable(true);
  this.currentStartYear = ko
    .observable(0)
    .subscribeTo('currentStartYear', true);
  this.currentEndYear = ko.observable(0).subscribeTo('currentEndYear', true);
  this.categoriesEndYear = ko.observable(0);
  this.currentYear = ko.observable(0);
  this.activeModal = ko.observable(false);
  this.modalTitle = ko.observable('');
  this.modalText = ko.observable('');
  this.totalDoneHours = ko.observable(0);
  this.hoursRequirement = ko.observable(80).subscribeTo('hoursRequirement', true);
  this.calculatorExtendedCourse = $('.calculator-extended-course');
  this.calculatorExtendedLeave = $('.calculator-extended-leave');
  // Which of the current bars / categories is expanded (if any).
  this.activeBar = ko.observable();
  this.periodStartYears = ko.observableArray();
  this.getPeriods();

  this.authorizationDate = ko.observable();
  this.showAuthorizationDate = ko.observable(false);
  // Get the categories needed for the calculator bars.
  this.getCategories();
  // Check if user changes from accountant to auditor.
  this.calculatorType.subscribe(function(value) {
    this.changeInAuthorizationType = true;
    this.getCategories();
    this.getPeriods();
  }, this);

  // Listen to change in current year and fetch the appropriate year.
  this.currentYear.subscribe(function() {
    this.getCategories();
  }, this);

  this.downloadFileUrl = ko.computed(function() {
    return (
      this.API.periodReportUrl +
      '/' +
      this.currentStartYear() +
      '?authorizationType=' +
      encodeURIComponent(this.calculatorType()) +
      (this.actorId ? '&actorId=' + encodeURIComponent(this.actorId) : '')
    );
  }, this);

  // When there is change in absence we want to get the categories (with hours),
  // because the period may affect the categories.
  ko.postbox.subscribe(
    'changeInAbsence',
    function() {
      this.getCategories();
    }.bind(this)
  );
  ko.postbox.subscribe(
    'changeInCategoryRequirement',
    function() {
      this.getCategories();
    }.bind(this)
  );
  // Listen to modal/popup requests.
  ko.postbox.subscribe(
    'openPopup',
    function(value) {
      this.activeModal(!this.activeModal());
      this.modalTitle(value.modalTitle);
      this.modalText(value.modalText);
    }.bind(this)
  );

  // Listen to when a uses buys a course (or rather, when a user adds it to the shopping cart).
  ko.postbox.subscribe(
    'buyCourse',
    function(course) {
      Cart.addCourseToCart(course);
    }.bind(this)
  );
};

CalculatorRN.prototype.getPeriods = function() {
  var url =
    this.API.periods +
    '?authorizationType=' +
    encodeURIComponent(this.calculatorType());
  APIHelper.get(
    url,
    function(response) {
      var startYears = [];
      for (var i = 0; i < response.length; i++) {
        var startYearDate = new Date(response[i].Start);
        startYears.push(startYearDate.getFullYear());
      }
      this.periodStartYears(startYears);
      var authDate = new Date(response[0].Start);
      var authDateString =
        '' +
        authDate.getDate() +
        '.' +
        (authDate.getUTCMonth() + 1) +
        '.' +
        authDate.getFullYear();
      this.authorizationDate(authDateString);
      this.showAuthorizationDate(startYears.length === 1);
    }.bind(this),
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: calculator.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

CalculatorRN.prototype.getCategories = function() {
  var url =
    this.API.categoryHours +
    '?authorizationType=' +
    encodeURIComponent(this.calculatorType());

  if (this.currentYear() !== 0) {
    url = url + '&startYear=' + encodeURIComponent(this.currentYear());
  }

  APIHelper.get(
    url,
    function(response) {
      this.categoriesEndYear(response.EndYear);
      this.handleCategories(response.Categories);
    }.bind(this),
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: calculator.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

CalculatorRN.prototype.handleCategories = function(categories) {
  var totalDoneHours = 0,
    i = 0,
    totalPlannedHoursCategories = 0,
    requiredHoursCurrentCategory = 0;

  if (this.changeInAuthorizationType || this.categories().length === 0) {
    this.changeInAuthorizationType = false;

    // We want to replace all the "normal" values with observables. This way we can detect changes
    // and update the values in the child component without actually reloading the whole component.
    for (i = 0; i < categories.length; i++) {
      requiredHoursCurrentCategory = categories[i].Requirement;
      totalPlannedHoursCategories +=
        categories[i].PlannedHoursFromCurrentCategory;
      categories[i].CategoryKey = categories[i].CategoryKey;
      categories[i].TotalHoursDone = ko.observable(
        categories[i].TotalStructuredHoursDone +
          categories[i].TotalUnstructuredHoursDone
      );
      categories[i].DoneStructuredHoursFromCurrentCategory = ko.observable(
        categories[i].DoneStructuredHoursFromCurrentCategory
      );
      categories[i].DoneUnstructuredHoursFromCurrentCategory = ko.observable(
        categories[i].DoneUnstructuredHoursFromCurrentCategory
      );
      categories[i].PlannedHoursFromCurrentCategory = ko.observable(
        categories[i].PlannedHoursFromCurrentCategory
      );
      categories[i].Requirement = ko.observable(requiredHoursCurrentCategory);
      categories[i].ShowMissingHoursError = ko.observable(
        this.showMissingHoursError(
          categories[i].TotalHoursDone(),
          requiredHoursCurrentCategory
        )
      );
      categories[i].UpdateCounter = ko.observable(0);
      totalDoneHours += categories[i].TotalHoursDone();
      categories[i].Shopping = ko.observable(0);
      categories[i].RemainingHours = ko.observable(
        Math.max(
          0,
          categories[i].Requirement() -
            categories[i].TotalHoursDone() -
            categories[i].PlannedHoursFromCurrentCategory()
        )
      );
    }
    this.categories(categories);
  } else {
    // Only change the values since we already have the categories.
    for (i = 0; i < this.categories().length; i++) {
      requiredHoursCurrentCategory = categories[i].Requirement;
      totalPlannedHoursCategories +=
        categories[i].PlannedHoursFromCurrentCategory;

      this.categories()[i].CategoryKey = categories[i].CategoryKey;
      this.categories()[i].TotalHoursDone(
        categories[i].TotalStructuredHoursDone +
          categories[i].TotalUnstructuredHoursDone
      );
      this.categories()[i].DoneStructuredHoursFromCurrentCategory(
        categories[i].DoneStructuredHoursFromCurrentCategory
      );
      this.categories()[i].DoneUnstructuredHoursFromCurrentCategory(
        categories[i].DoneUnstructuredHoursFromCurrentCategory
      );
      this.categories()[i].PlannedHoursFromCurrentCategory(
        categories[i].PlannedHoursFromCurrentCategory
      );
      this.categories()[i].Requirement(requiredHoursCurrentCategory);
      this.categories()[i].ShowMissingHoursError(
        this.showMissingHoursError(
          this.categories()[i].TotalHoursDone(),
          requiredHoursCurrentCategory
        )
      );
      this.categories()[i].UpdateCounter(
        this.categories()[i].UpdateCounter() + 1
      );

      totalDoneHours += this.categories()[i].TotalHoursDone();
      this.categories()[i].RemainingHours(
        Math.max(
          0,
          this.categories()[i].Requirement() -
            this.categories()[i].TotalHoursDone() -
            this.categories()[i].PlannedHoursFromCurrentCategory()
        )
      );
      this.categories()[i].Shopping(0);
    }
  }
  ko.postbox.publish(
    'totalPlannedHoursCategories',
    totalPlannedHoursCategories
  );
  this.totalDoneHours(totalDoneHours);
  this.categories.valueHasMutated();
};

CalculatorRN.prototype.showHoursType = function(type) {
  ko.postbox.publish('showHoursType', type);
};

//TODO: This is just a temporary fix
CalculatorRN.prototype.showMissingHoursError = function(
  doneHours,
  requiredHours
) {
  /*var currentDateYear = new Date().getFullYear(),
    currentDateMonth = new Date().getMonth();
  return (
    this.categoriesEndYear() === currentDateYear &&
    doneHours < requiredHours &&
    (currentDateMonth === MONTH_TYPE.NOVEMBER ||
      currentDateMonth === MONTH_TYPE.DECEMBER ||
      this.showRequirementWarningsAllYear())
  );*/
  return false;
};
CalculatorRN.prototype.previousYear = function() {
  var indexOfCurrentStartYear = this.periodStartYears().indexOf(
    this.currentStartYear()
  );
  var previousStartYear =
    indexOfCurrentStartYear - 1 >= 0
      ? this.periodStartYears()[indexOfCurrentStartYear - 1]
      : this.currentStartYear();
  this.currentYear(previousStartYear);
  CalculatorTracking.trackYearChange(
    'previousYear',
    this.currentYear(),
    this.currentEndYear() >= new Date().getFullYear()
  );
  ko.postbox.publish('currentYearChange', this.currentYear());
  this.showAuthorizationDate(
    indexOfCurrentStartYear - 1 === 0 || indexOfCurrentStartYear === 0
  );
};

CalculatorRN.prototype.nextYear = function() {
  var indexOfCurrentStartYear = this.periodStartYears().indexOf(
    this.currentStartYear()
  );
  var nextStartYear =
    indexOfCurrentStartYear + 1 < this.periodStartYears().length
      ? this.periodStartYears()[indexOfCurrentStartYear + 1]
      : this.currentStartYear();
  this.currentYear(nextStartYear);
  CalculatorTracking.trackYearChange(
    'nextYear',
    this.currentYear(),
    this.currentEndYear() >= new Date().getFullYear()
  );
  ko.postbox.publish('currentYearChange', this.currentYear());
  this.showAuthorizationDate(indexOfCurrentStartYear + 1 === 0);
};

CalculatorRN.prototype.toggleAddCourse = function() {
  var self = this;
  if (this.showAddCourse()) {
    this.calculatorExtendedCourse.slideUp(250, 'easeOutQuad');
    this.showAddCourse(false);
    CalculatorTracking.trackCloseExtendedPages('course', 'addCourse');
  } else {
    this.calculatorExtendedLeave.slideUp(250, 'easeOutQuad', function() {
      self.calculatorExtendedCourse.slideDown(250, 'easeOutQuad', function() {
        var scrollToTarget = self.calculatorExtendedCourse.offset().top - 100;
        self.$htmlBody.animate({ scrollTop: scrollToTarget + 'px' });
      });
      self.showAddCourse(true);
      self.showLeaveBlock(false);
      CalculatorTracking.trackExtendedPages('course', 'addCourse', 'expand');
    });
  }
};

CalculatorRN.prototype.toggleLeaveBlock = function() {
  var self = this;
  if (this.showLeaveBlock()) {
    this.calculatorExtendedLeave.slideUp(250, 'easeOutQuad');
    this.showLeaveBlock(false);
    CalculatorTracking.trackCloseExtendedPages('absence', 'addEditAbsence');
  } else {
    this.calculatorExtendedCourse.slideUp(250, 'easeOutQuad', function() {
      self.calculatorExtendedLeave.slideDown(250, 'easeOutQuad', function() {
        // Get the position and subtract the padding.
        var scrollToTarget = self.calculatorExtendedLeave.offset().top - 100;
        self.$htmlBody.animate({ scrollTop: scrollToTarget + 'px' });
      });
      self.showLeaveBlock(true);
      self.showAddCourse(false);

      CalculatorTracking.trackExtendedPages(
        'absence',
        'addEditAbsence',
        'expand'
      );
    });
  }
};

CalculatorRN.prototype.toggleCalculatorDescription = function() {
  this.showCalculatorDescription(!this.showCalculatorDescription());
};

CalculatorRN.prototype.toggleBars = function(index) {
  this.activeBar(index);
};

CalculatorRN.prototype.closeModal = function() {
  this.activeModal(false);
};

CalculatorRN.prototype.changeCalculatorType = function(type) {
  ko.postbox.publish('authorizationType', type);
};

module.exports = CalculatorRN;
